// Textos comunes: menú, barra superior, carga, selector. Claves: area.tema
export default {
  es: {
    'login.claveCorta': 'La contraseña debe tener al menos 6 caracteres.',
    'login.confirmaTitulo': 'Aún falta confirmar tu correo.',
    'login.confirmaAyuda': 'Te enviamos un enlace al registrarte. Revisa tu bandeja y la carpeta de spam, o pide uno nuevo.',
    'login.reenviar': 'Reenviar enlace de confirmación',
    'login.escribeCorreo': 'Escribe tu correo arriba para reenviarlo.',
    'login.unaSesion': 'Por seguridad solo puedes usar tu cuenta en un equipo a la vez. Si entraste desde otro lugar, esa sesión se cerró.',
    'login.sesionCerradaTitulo': 'Tu sesión se cerró.',
    'login.sesionCerradaAyuda': 'Entraste desde otro equipo o pasó mucho tiempo. Por seguridad solo puedes usar tu cuenta en un equipo a la vez. Entra de nuevo para continuar.',
    'login.titulo': 'Bienvenido a Panther7',
    'login.subtitulo': 'Entra a tu cuenta para ver tus inversiones.',
    'login.correo': 'Correo electrónico',
    'login.correoEjemplo': 'tu@email.com',
    'login.clave': 'Contraseña',
    'login.ocultar': 'Ocultar',
    'login.mostrar': 'Mostrar',
    'login.entrando': 'Entrando…',
    'login.entrar': 'Entrar a mi cuenta',
    'login.olvido': '¿Olvidaste tu contraseña?',
    'login.sinCuenta': '¿Aún no tienes cuenta?',
    'login.crear': 'Crear mi cuenta',
    'login.nota': 'Invierte desde USDT 50 en proyectos respaldados por activos seleccionados.',
    'srv:Usuario o clave incorrecta': 'Usuario o clave incorrecta',
    'srv:Usuario inactivo.': 'Usuario inactivo.',
    'nav.inicio': 'Inicio',
    'nav.movimientos': 'Movimientos',
    'nav.proyectos': 'Proyectos',
    'nav.inversiones': 'Mis inversiones',
    'nav.ofertas': 'Mis ofertas',
    'nav.wallet': 'Wallet Blockchain',
    'nav.deposito': 'Depósito',
    'nav.retiro': 'Retiro',
    'nav.tarjetas': 'Tarjetas',
    'nav.cuenta': 'Mi cuenta',
    'comun.cerrarSesion': 'Cerrar sesión',
    'comun.idioma': 'Idioma',
    'comun.cargando': 'Cargando…',
    'carga.paso1': 'Verificando tus datos…',
    'carga.paso2': 'Cargando tu saldo y movimientos…',
    'carga.paso3': 'Preparando tu panel…',
    'carga.lento': 'Está tardando más de lo normal. Puedes esperar un momento más o volver a intentarlo.',
    'carga.reintentar': 'Reintentar',
    'comun.plataformaDemo': 'PLATAFORMA DEMO',
  },
  en: {
    'login.claveCorta': 'Your password must be at least 6 characters.',
    'login.confirmaTitulo': 'You still need to confirm your email.',
    'login.confirmaAyuda': 'We sent you a link when you signed up. Check your inbox and spam folder, or request a new one.',
    'login.reenviar': 'Resend confirmation link',
    'login.escribeCorreo': 'Type your email above to resend it.',
    'login.unaSesion': 'For security, you can only use your account on one device at a time. If you signed in elsewhere, that session was closed.',
    'login.sesionCerradaTitulo': 'Your session was closed.',
    'login.sesionCerradaAyuda': 'You signed in on another device or a long time passed. For security, you can only use your account on one device at a time. Sign in again to continue.',
    'login.titulo': 'Welcome to Panther7',
    'login.subtitulo': 'Sign in to see your investments.',
    'login.correo': 'Email',
    'login.correoEjemplo': 'you@email.com',
    'login.clave': 'Password',
    'login.ocultar': 'Hide',
    'login.mostrar': 'Show',
    'login.entrando': 'Signing in…',
    'login.entrar': 'Sign in',
    'login.olvido': 'Forgot your password?',
    'login.sinCuenta': "Don't have an account yet?",
    'login.crear': 'Create my account',
    'login.nota': 'Invest from 50 USDT in projects backed by selected assets.',
    'srv:Usuario o clave incorrecta': 'Incorrect email or password',
    'srv:Usuario inactivo.': 'Inactive user.',
    'nav.inicio': 'Home',
    'nav.movimientos': 'Transactions',
    'nav.proyectos': 'Projects',
    'nav.inversiones': 'My investments',
    'nav.ofertas': 'My offers',
    'nav.wallet': 'Blockchain wallet',
    'nav.deposito': 'Deposit',
    'nav.retiro': 'Withdraw',
    'nav.tarjetas': 'Cards',
    'nav.cuenta': 'My account',
    'comun.cerrarSesion': 'Sign out',
    'comun.idioma': 'Language',
    'comun.cargando': 'Loading…',
    'carga.paso1': 'Verifying your details…',
    'carga.paso2': 'Loading your balance and transactions…',
    'carga.paso3': 'Getting your dashboard ready…',
    'carga.lento': 'This is taking longer than usual. You can wait a little more or try again.',
    'carga.reintentar': 'Try again',
    'comun.plataformaDemo': 'DEMO PLATFORM',
  },
  pt: {
    'login.claveCorta': 'A senha deve ter pelo menos 6 caracteres.',
    'login.confirmaTitulo': 'Ainda falta confirmar seu e-mail.',
    'login.confirmaAyuda': 'Enviamos um link quando você se cadastrou. Verifique sua caixa de entrada e a pasta de spam, ou peça um novo.',
    'login.reenviar': 'Reenviar link de confirmação',
    'login.escribeCorreo': 'Digite seu e-mail acima para reenviá-lo.',
    'login.unaSesion': 'Por segurança, você só pode usar sua conta em um dispositivo por vez. Se você entrou em outro lugar, essa sessão foi encerrada.',
    'login.sesionCerradaTitulo': 'Sua sessão foi encerrada.',
    'login.sesionCerradaAyuda': 'Você entrou em outro dispositivo ou passou muito tempo. Por segurança, você só pode usar sua conta em um dispositivo por vez. Entre novamente para continuar.',
    'login.titulo': 'Bem-vindo à Panther7',
    'login.subtitulo': 'Entre na sua conta para ver seus investimentos.',
    'login.correo': 'E-mail',
    'login.correoEjemplo': 'voce@email.com',
    'login.clave': 'Senha',
    'login.ocultar': 'Ocultar',
    'login.mostrar': 'Mostrar',
    'login.entrando': 'Entrando…',
    'login.entrar': 'Entrar na minha conta',
    'login.olvido': 'Esqueceu sua senha?',
    'login.sinCuenta': 'Ainda não tem conta?',
    'login.crear': 'Criar minha conta',
    'login.nota': 'Invista a partir de 50 USDT em projetos lastreados por ativos selecionados.',
    'srv:Usuario o clave incorrecta': 'E-mail ou senha incorretos',
    'srv:Usuario inactivo.': 'Usuário inativo.',
    'nav.inicio': 'Início',
    'nav.movimientos': 'Movimentos',
    'nav.proyectos': 'Projetos',
    'nav.inversiones': 'Meus investimentos',
    'nav.ofertas': 'Minhas ofertas',
    'nav.wallet': 'Carteira blockchain',
    'nav.deposito': 'Depósito',
    'nav.retiro': 'Saque',
    'nav.tarjetas': 'Cartões',
    'nav.cuenta': 'Minha conta',
    'comun.cerrarSesion': 'Sair',
    'comun.idioma': 'Idioma',
    'comun.cargando': 'Carregando…',
    'carga.paso1': 'Verificando seus dados…',
    'carga.paso2': 'Carregando seu saldo e movimentos…',
    'carga.paso3': 'Preparando seu painel…',
    'carga.lento': 'Está demorando mais que o normal. Você pode esperar mais um pouco ou tentar novamente.',
    'carga.reintentar': 'Tentar novamente',
    'comun.plataformaDemo': 'PLATAFORMA DEMO',
  },
};
